'use strict';

var ArrayBufferViewCore = require('../internals/array-buffer-view-core');

var $findLastIndex = require('../internals/array-iteration-from-last').findLastIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.findLastIndex` method
// https://github.com/tc39/proposal-array-find-from-last

exportTypedArrayMethod('findLastIndex', function findLastIndex(predicate
/* , thisArg */
) {
  return $findLastIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});